import React from "react";
import "../../pages/Orders/order.css"
import Helpers from "../../helpers/helpers";
//Import Breadcrumb

const CustomLabel = ({ label, border, borderRadius, color, backgroundColor, height, marginLeft, marginRight }) => {
    return (
        <React.Fragment>
            <div
                className={"label-container"}
                style={{
                    border: border,
                    borderRadius: borderRadius || 5,
                    color: color,
                    backgroundColor: backgroundColor,
                    margin: 0,
                    marginLeft: marginLeft || 0,
                    marginRight: marginRight || 0,
                    height: height || 'fit-content'
                }}>
                {label}
            </div>
        </React.Fragment>
    );
};

const StatusLabel = ({ label, marginLeft }) => {
    return (
        <React.Fragment>
            <div
                className={
                    ((Helpers.capitalize(label) === 'Active' || Helpers.capitalize(label) === 'Published') ? "status-label-active" :
                        "status-label-inactive") + " label-container"
                }
                style={{ marginLeft: marginLeft || 10 }}
            >{Helpers.capitalize(label)}</div>
        </React.Fragment>
    );
};


const SchStatusLabel = ({ label, marginLeft }) => {
    return (
        <React.Fragment>
            <div
                className={
                    (label === 'active' ? "status-label-active"
                        : label === "inactive" ? "status-label-inactive"
                            : label === "expired" ? "order-label-pending-order" : "item-label-configurable"
                    )
                    + " label-container"
                }
                style={{ marginLeft: marginLeft || 10 }}
            >{Helpers.capitalize(label)}</div>
        </React.Fragment>
    );
};


const StatusVoucherLabel = ({ label, marginLeft }) => {
    return (
        <React.Fragment>
            <div
                className={
                    (label === 'active' ? "status-label-active"
                        : label === "expired" ? "status-label-inactive"
                            : label === "assigned" ? "order-label-pending-order" : "item-label-configurable"
                    )
                    + " label-container"
                }
                style={{ marginLeft: marginLeft || 10 }}
            >{Helpers.capitalize(label)}</div>
        </React.Fragment>
    );
};


const StatusByIDLabel = ({ label, marginLeft }) => {
    return (
        <React.Fragment>
            <div
                className={
                    (label === 1 ? "status-label-active" :
                        "status-label-inactive") + " label-container"
                }
                style={{ marginLeft: marginLeft || 10 }}
            >{label === 1 ? "Active" : "Inactive"}</div>
        </React.Fragment>
    );
};

const ItemTag = ({ label, marginLeft }) => {
    return (
        <React.Fragment>
            <div
                className={
                    (label === 'configurable' ? "item-label-configurable " :
                        "status-label-active") + " label-container"}
                style={{ marginLeft: marginLeft || 10, maxHeight: 25 }}
            >{Helpers.capitalize(label)}</div>
        </React.Fragment>
    );
};

const PaymentStatusLabel = ({ label, marginLeft }) => {
    let labelText = label === "Pending" ? "Unpaid" : label;

    return (
        <React.Fragment>
            <div
                className={(labelText === 'Paid' ? "payment-label-paid" : "payment-label-unpaid") + " label-container"}
                style={{ marginLeft: marginLeft || 10 }}
            >
                {labelText}
            </div>
        </React.Fragment>
    );
};

const FreeGiftLabel = ({ marginRight }) => {
    return (
        <React.Fragment>
            <div className={"free-gift-label label-container"} style={{ marginRight: marginRight || 10, marginLeft: 0 }}>Free Gift</div>
        </React.Fragment>
    );
};

const RefundedLabel = ({ marginLeft, height }) => {
    return (
        <React.Fragment>
            <div className={"refunded-label label-container"} style={{ marginLeft: marginLeft || 10, height: height && height }}>Refunded</div>
        </React.Fragment>
    );
};

const OrderLabel = ({ label, marginLeft, height }) => {
    return (
        <React.Fragment>
            <div
                className={`order-label-${(label === 'payment_failed' || label === 'cancelled' || label === 'refunded') ? 'payment-failed' :
                    label === 'partially_refunded' ? 'partially-refunded' : label === 'pending' ? 'pending-order' : label === 'ordered' ? 'confirmed' : label} label-container`}
                style={{ marginLeft: marginLeft || 10, maxHeight: 25, height: height && height }}
            >
                <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{Helpers.displayStatusString(label)}</div>
            </div>
        </React.Fragment>
    );
};

const SupportStatusLabel = ({ label, marginLeft }) => {
    return (
        <React.Fragment>
            <div
                className={(label === 'pending' ? "order-label-pending-order" : "status-label-active") + " label-container"}
                style={{ marginLeft: marginLeft || 10 }}
            >
                {Helpers.capitalize(label)}
            </div>
        </React.Fragment>
    );
};

const ReviewStatusLabel = ({ label, marginLeft }) => {
    return (
        <React.Fragment>
            <div
                className={(label === 'pending_approval' ? "order-label-pending-order" : label === 'approved' ? "status-label-active" : "status-label-inactive") + " label-container"}
                style={{ marginLeft: marginLeft || 10 }}
            >
                {Helpers.displayReviewStatusString(label)}
            </div>
        </React.Fragment>
    );
};

const ProductStatusLabel = ({ label, marginLeft }) => {
    return (
        <React.Fragment>
            <div
                className={(
                    label === 2 ? "product-label-pending-order" :
                        label === 1 ? "status-label-active" :
                            label === 'approved' ? "product-label-active" :
                                label === 'rejected' ? "product-label-inactive" :
                                    label === 'pending_approval' ? "order-label-pending-order" :
                                        "status-label-inactive") + " label-container"}
                style={{ marginLeft: marginLeft || 10 }}
            >
                {Helpers.displayProductStatusString(label)}
            </div>
        </React.Fragment>
    );
};

export default {
    CustomLabel,
    StatusVoucherLabel,
    ItemTag,
    OrderLabel,
    StatusByIDLabel,
    PaymentStatusLabel,
    FreeGiftLabel,
    StatusLabel,
    RefundedLabel,
    SupportStatusLabel,
    ReviewStatusLabel,
    ProductStatusLabel,
    SchStatusLabel,
};
